import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      label: 'Lifeguard Courses',
      path: '/lifeguarding',
      color: 'blue'
    },
    {
      label: 'First Aid & CPR',
      path: '/first-aid',
      color: 'red'
    },
    {
      label: 'Instructor Courses',
      path: '/instructor',
      color: 'green'
    },
    {
      label: 'Recertifications',
      path: '/recertifications',
      color: 'orange'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
    red: 'bg-red-100 text-red-700 hover:bg-red-200',
    green: 'bg-green-100 text-green-700 hover:bg-green-200',
    orange: 'bg-orange-100 text-orange-700 hover:bg-orange-200'
  };

  return (
    <nav className="bg-white shadow-md dark:bg-gray-900 sticky top-0 z-50">
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="PSA Toronto Logo" className="h-8 rounded-md" />
          <span className="text-2xl font-semibold text-gray-800 dark:text-white">PSA Toronto</span>
        </Link>

        <button
          className="md:hidden p-2 rounded text-gray-600 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div className="hidden md:flex gap-3">
          {menuItems.map(({ label, path, color }) => (
            <Link
              key={path}
              to={path}
              className={`px-4 py-2 rounded-md text-sm font-medium transition ${colorClasses[color]}`}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden px-4 pb-4 flex flex-col gap-4">
          {menuItems.map(({ label, path, color }) => (
            <Link
              key={path}
              to={path}
              className={`block px-4 py-2 rounded-md text-sm font-medium transition ${colorClasses[color]}`}
              onClick={() => setIsOpen(false)}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
